// extracted by mini-css-extract-plugin
export default {"ledToPackageBankAccount":"LedToPackagedBankAccount_ledToPackageBankAccount__QDmxA"};